import { Resource } from './resource';
import { Filter } from './filters';
import { Sort, SortDirection, SortColumn } from '../types/sort';
import { Organization, Sensor } from './api';

export type MultiPointInstallationAddSensorSidebarState = {
  selectedSensorSerialNumbers: Array<Sensor['serial_number']>;

  filters: Array<Filter>;
  searchText: string;
  sort: Sort;

  page: number;

  resource: Resource<{
    total: number;
    sensors: Array<Sensor>;
    fetchingMoreSensors: Resource<null>; // There is no data in this resource, it's only used as a status
  }>;
};

export enum MultiPointInstallationAddSensorSidebarActionTypes {
  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_OPEN = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_OPEN',

  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LOAD_START = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LOAD_START',
  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LOAD_ERROR = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LOAD_ERROR',
  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LOAD_COMPLETE = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LOAD_COMPLETE',

  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_FILTERS = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_FILTERS',
  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_SEARCH_TEXT = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_SEARCH_TEXT',
  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_SORT = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_SORT',

  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_CHANGE_CHECKS = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_CHANGE_CHECKS',

  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_PAGE = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LIST_SET_PAGE',
  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_NEXT_PAGE_LOAD_LOADING = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LIST_NEXT_PAGE_LOAD_LOADING',
  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_NEXT_PAGE_LOAD_ERROR = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LIST_NEXT_PAGE_LOAD_ERROR',
  MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_NEXT_PAGE_LOAD_COMPLETE = 'MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LIST_NEXT_PAGE_LOAD_COMPLETE',
}

export type MultiPointInstallationAddSensorSidebarAction =
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_OPEN;
      organizationId: Organization['id'] | null;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LOAD_START;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LOAD_ERROR;
      error: any;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_LOAD_COMPLETE;
      sensors: Array<Sensor>;
      total: number;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_SEARCH_TEXT;
      text: string;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_FILTERS;
      filters: Array<Filter>;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_SORT;
      direction: SortDirection;
      column: SortColumn;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_CHANGE_CHECKS;
      serialNumbers: Array<Sensor['serial_number']>;
      checked: boolean;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_SET_PAGE;
      value: number;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_NEXT_PAGE_LOAD_LOADING;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_NEXT_PAGE_LOAD_ERROR;
      error: any;
    }
  | {
      type: MultiPointInstallationAddSensorSidebarActionTypes.MULTI_POINT_INSTALLATION_ADD_SENSOR_SIDEBAR_NEXT_PAGE_LOAD_COMPLETE;
      sensors: Array<Sensor>;
    };
